import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';
import CustomTab from '@/widget/CustomTab';
import Holding from './components/Holding';
import Order from './components/Order';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Swiper as SwiperType } from 'swiper';
import { useBoomWallet } from '@boomeme/wallet-sdk';
import { useAppStore } from '@/store';

export default () => {
  const { fwClass } = useAppStore();
  const { isConnected } = useBoomWallet();
  const [activeIndex, setActiveIndex] = useState(0);
  const { t } = useTranslation();
  const tabs = [t('Trade.holding'), t('Trade.orders')];
  const swiperRef = useRef<SwiperType | null>(null);

  useEffect(() => {
    if (swiperRef.current && swiperRef.current.activeIndex !== activeIndex) {
      swiperRef.current.slideTo(activeIndex);
    }
  }, [activeIndex]);

  if (!isConnected) return null;

  return (
    <div>
      <div className="sticky top-0 z-10 bg-primaryBgColor py-[8px]">
        <CustomTab tabs={tabs} wrapperClassName={cn(fwClass, 'mb-[16px]')} activeIndex={activeIndex} onTabChange={setActiveIndex} />
      </div>
      <Swiper
        className="w-full h-full"
        initialSlide={activeIndex}
        onSlideChange={(e) => setActiveIndex(e.activeIndex)}
        onSwiper={(swiper) => (swiperRef.current = swiper)}
      >
        <SwiperSlide>
          <Holding />
        </SwiperSlide>
        <SwiperSlide>
          <Order />
        </SwiperSlide>
      </Swiper>
    </div>
  );
};
